import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-construction',
  templateUrl: './construction.component.html',
  styleUrls: ['./construction.component.scss']
})
export class AgencyConstructionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
